import React from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';
import {Machine, Service} from "~/types";
import useTranslation from "~/app/hooks/useTranslation";
import LinkWrapper from "~/app/common/LinkWrapper";
import {useParams} from 'react-router-dom';
import {MACHINES_DETAILS_ROUTES} from "~/machines/Details/Router";
import {route} from "~/app/helpers/route";
import { useStoreState } from '~/store';

export interface ListItemProps {
    item: Service
    listClassName?: string
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({item, listClassName}) => {
    const {t} = useTranslation("service");
    const {id} = useParams<{ id: Machine['id'] }>();
    const showCompleted = useStoreState(state => state.service.showCompleted);

    return (
        <LinkWrapper className={`${classes['list-item']} ${listClassName && classes[listClassName]}`}
            to={route(MACHINES_DETAILS_ROUTES.serviceDetails, {id, serviceId: item.id})}>
            <div className={classes['info']}>
                <div className={classes['title']}>{item.serviceText}</div>
                <div className={classes['details']}>
                    <span className={`${classes['due-status']} ${!showCompleted ? classes[item.serviceStatus] : ''}`.trim()}>{t('dueHoursText')} : {item.dueHours ?? (item.dateDiff ? item.dateDiff + ' d' : '')}</span>
                    <span className={classes['interval-type']}>{item.intervalTypeText}</span>
                    <span className={classes['status']}>{t(`statuses.${item.status}`)}</span>
                </div>
            </div>
            <div className={classNames(classes['right-icon-wrap'])}>
                <Icon name="keyboard_arrow_right"/>
            </div>
        </LinkWrapper>
    );
};

export default ListItem
